// extracted by mini-css-extract-plugin
module.exports = {"header":"terms-and-conditions_header_1WeNh","title":"terms-and-conditions_title_2hVXj","body":"terms-and-conditions_body_1sz5e","text":"terms-and-conditions_text_3ZwKG"};